import Script from 'next/script'
import { useEffect, useState } from 'react'

import { TOPBAR_LAZY_RELATIVE_PATH } from './constants'
import getQueryArgs from './get-query-args'
import styles from './topbar-lazy.module.scss'
import { TopbarSkeleton } from './topbar-skeleton'
import { LazyTopbarOptions, TopbarResponsePayload } from './types'

export function TopbarLazy(props: LazyTopbarOptions) {
  const [payload, setPayload] = useState<TopbarResponsePayload>()
  const [started, setStarted] = useState(false)
  const [showCriticalCss, setShowCriticalCss] = useState(true)
  useEffect(() => {
    if (started) return
    async function fetchTopbar() {
      setStarted(true)
      try {
        const queryString = getQueryArgs({
          ...props,
          criticalCss: true,
          output: 'json',
        }).toString()
        const rawResponse = await fetch(`${TOPBAR_LAZY_RELATIVE_PATH}${queryString}`)
        const jsonPayload = await rawResponse.json()
        window.topbarInitialState = jsonPayload.topbarInitialState
        setPayload(jsonPayload)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    }
    fetchTopbar()
  }, [props, started])
  if (!payload) {
    return <TopbarSkeleton hideNavbar={props.hideNavbar} />
  }
  return (
    <>
      {showCriticalCss && <style dangerouslySetInnerHTML={{ __html: payload.criticalCss || '' }} />}
      <link
        data-testid="topbar-lazy-stylesheet"
        rel="stylesheet"
        type="text/css"
        href={payload.css}
        onLoad={() => setShowCriticalCss(false)}
      />
      <div
        className={styles['TopbarLazy-loadedContent']}
        dangerouslySetInnerHTML={{ __html: payload.html }}
      />
      <Script src={payload.js} />
    </>
  )
}
